<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
     Procurement Order List
    </v-card-title> -->
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="addData"
              v-if="role.create"
            >
              Add Vehicle
            </v-btn>
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('all')}"
                    
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('filter')}"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <div class="d-flex">
        <v-select
        style=" max-width: 150px;"
          :items="option_filter"
          label="Select"
          v-model="searchCategory"
          @change="search=''"
           item-text="text"
          item-value="value"
        
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-text-field
        :disabled="!searchCategory"
        v-model="search"
        label="Search"
          class="ma-2"
        single-line
        hide-details
      >
      </v-text-field>
        <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
    </div>
    </v-card-title>
    <!-- <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
      :options="{'itemsPerPage':50}"
    > -->
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :options.sync="options"
      :server-items-length="totalDataTable"
      :page="page"
      :pageCount="numberOfPages"
      :footer-props="{'items-per-page-options':[30, 50, 100]}"
    >
    <template v-slot:[`header.vehicle_business_unit`]="{ header }">
           <v-select
                style=" font-size:10px;"
                :items="optionBusinessUnit"
                :label="header.text"
                v-model="valueBusinessUnit"
                @change="getList"
                item-text="business_unit_name"
                item-value="id"
              
                class="ma-2"
              hide-details
              >
            </v-select>
         </template>
    <template v-slot:[`header.vehicle_type`]="{ header }">
           <v-select
                style=" font-size:10px;"
                :items="optionVehicleType"
                :label="header.text"
                v-model="valueVehicleType"
                @change="getList"
                :item-text="item => item.id==0? 'All' :item.vehicle_brand.vehicle_brand_name +', '+ item.vehicle_model+' '+ item.vehicle_year_model"
                item-value="id"
              
                class="ma-2"
              hide-details
              >
            </v-select>
         </template>
     <template v-slot:[`item.detail`]="{ item }">
          <!-- <router-link :to="{name: 'Detail Vehicle', params: { id: item.id }}" class="btn btn-primary">Detail
          </router-link> -->
          <router-link :to="{name: 'Detail Vehicle', params: { id: item.id }}" class="btn btn-primary">Detail
          </router-link>
          <!-- this.$router.replace({ name: 'Edit Vehicle', params: {vehicle: id, id } }) -->
    </template>
     <template v-slot:[`item.vehicle_type`]="{ item }">
      <span v-if="item.vehicle_type"> {{item.vehicle_type.vehicle_brands.vehicle_brand_name +", "+ item.vehicle_type.vehicle_model +" "+ item.vehicle_type.vehicle_year_model}}</span>
        
    </template>
    <template v-slot:[`item.vehicle_business_unit`]="{ item }">
         {{item.vehicle_business_unit.business_unit_name}}
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          
          <v-list-item @click="detailVehicle(item.id)">
            <v-list-item-title x-small>Detail</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role.update" @click="editVehicle(item.id)">
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item v-if="role.delete && item.driver_status == 0" @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-menu>
    </template>
    
    
    </v-data-table>
    
  </v-card>
    </template>
  </resizable-page>
  
  </v-app>
  <modal ref="modalAddPage">
    <template v-slot:header>
      <div style="text-align:center; margin:auto;">
      <h3 >ADD VEHICLE</h3>
      </div>
      <md-button class="md-icon-button md-dense md-round"  @click="modalCloseAdd()">
        <md-icon >close</md-icon>
      </md-button>
    </template>
    <template v-slot:body >
      <add-vehicle />
    </template>
  </modal>
  <modal ref="modalEditPage">
    <template v-slot:header>
      <div style="text-align:center; margin:auto;">
      <h3 >EDIT VEHICLE</h3>
      </div>
      <md-button class="md-icon-button md-dense md-round"  @click="modalCloseEdit()">
        <md-icon >close</md-icon>
      </md-button>
    </template>
    <template v-slot:body >
      <edit-vehicle :data_id="$refs.modalEditPage.data"/>
    </template>
  </modal>
  <modal ref="modalDetailPage" >
    <template v-slot:body >
      <detail-vehicle :data_id="$refs.modalDetailPage.data"/>
    </template>
  </modal>
</div>
</template>


<script>
import vuetify from '@/plugins/vuetify'
import JsonExcel from "vue-json-excel";
import AddVehicle from "@/pages/Dashboard/Workshop/Vehicle/AddVPage.vue";
import DetailVehicle from "@/pages/Dashboard/Workshop/Vehicle/DetailVPage.vue";
import EditVehicle from "@/pages/Dashboard/Workshop/Vehicle/EditVPage.vue";
import { Modal } from "@/components";
import { ResizablePage } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage, Modal, "add-vehicle": AddVehicle, "detail-vehicle": DetailVehicle, "edit-vehicle": EditVehicle
  },
    vuetify,
    data () {
      return {
        mounted:true,
        optionVehicleType:null,
        valueVehicleType:0,
        valueBusinessUnit:0,
       optionBusinessUnit:null,
        searchValue:null,
        searchCategory:null,
        option_filter: [ { text: 'Vehicle No.', value: 'vehicle_door_no' },
          { text: 'Police No.', value: 'vehicle_plate_no'}],
        page: 1,
        totalDataTable: 0,
        numberOfPages: 0,
        loadTable: false,
        role: "",
        search: '',
        options: {},
        headers: [
          // {
          //   text: 'Detail',
          //   align: 'start center',
          //   value: 'detail',
          //   sortable: false
          // },
          {
            text: 'Actions',
            align: 'start center',
            value: 'actions',
            sortable: false
          },
          { text: 'Vehicle No.', value: 'vehicle_door_no' },
          { text: 'Vehicle Type', value: 'vehicle_type',sortable: false},
          { text: 'Police No.', value: 'vehicle_plate_no'},
          { text: 'Business Unit', value: 'vehicle_business_unit',sortable: false},
          { text: 'Created At', value: 'created_at', align: 'center'},
        ],
        table: [],
        worksheetName: "Vehicles",
        fileName:"Vehicles.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        exportAll:[],
        field_export: {
               no: 'no',
              vehicle_door_no: 'vehicle_door_no',
              vehicle_plate_no: 'vehicle_plate_no',
              vehicle_businiss_unit: 'vehicle_businiss_unit',
              vehicle_model: 'vehicle_model',
              vehicle_fuel_type: 'vehicle_fuel_type',
              vehicle_body_color: 'vehicle_fuel_type',
              vehicle_plate_color: 'vehicle_plate_color',
              vehicle_registration_year: 'vehicle_registration_year',
              vehicle_registration_name: 'vehicle_registration_name',
              vehicle_production_year: 'vehicle_production_year',
              vehicle_chassis_no: 'vehicle_chassis_no',
              vehicle_engine_no: 'vehicle_engine_no',
              no_document: 'no_document',
              vehicle_document_type: 'vehicle_document_type',
              vehicle_document_no: 'vehicle_document_no',
              vehicle_document_expire_date: 'vehicle_document_expire_date',
              vehicle_document_tax_expire_date: 'vehicle_document_tax_expire_date',
              vehicle_document_remark: 'vehicle_document_remark',
              no_accesory: 'no_accesory',
              vehicle_accesory_type: 'vehicle_accesory_type',
              vehicle_accesory_serial_no: 'vehicle_accesory_serial_no',
              vehicle_accesory_installation_date: 'vehicle_accesory_installation_date',
              vehicle_accesory_installation_by: 'vehicle_accesory_installation_by',
              vehicle_accesory_remark: 'vehicle_accesory_remark',
              created_at: 'created_at',
              updated_at: 'updated_at',
          
        },
      }
    },
    watch: {
    options: {
      handler() {
        if( !this.mounted){
          this.getList();
        }
      },
    },
    deep: true,
  },
    async mounted() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
      this.onMounted()
    this.getList();
    this.mounted = false
    },
     methods: {
       // ambil data yang dibutuhkan

       async onMounted(){
         await this.$store.dispatch("workshop_vehicle_type/list")
         this.optionVehicleType = await this.$store.getters["workshop_vehicle_type/list"]
         this.optionVehicleType.unshift({business_unit_name:"All",id:0});
          await this.$store.dispatch("workshop_business_unit/list");
         this.optionBusinessUnit = await this.$store.getters["workshop_business_unit/list"];
          this.optionBusinessUnit.unshift({business_unit_name:"All",id:0});

       },
    async getList() {
      this.loadTable= true
      const { page, itemsPerPage,sortBy,sortDesc } = this.options;
      console.log(this.options)
      let pageNumber = page;
      
      
      var query = {"page":{number:pageNumber,size:itemsPerPage}}

      if(sortBy.length!=0){
        var  sort=sortBy[0]
        if(sortDesc[0]){
          sort="-"+sortBy[0]
        }
        query.sort = sort
      }

      if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }

      if(this.valueBusinessUnit!=0){
        if(query.filter){
          Object.assign(query.filter, {vehicle_business_unit:this.valueBusinessUnit});
        }
        else{
          query.filter = {vehicle_business_unit:this.valueBusinessUnit}
        }
      }

      if(this.valueVehicleType!=0){
        if(query.filter){
          Object.assign(query.filter, {vehicle_type:this.valueVehicleType});
        }
        else{
          query.filter = {vehicle_type:this.valueVehicleType}
        }
      }
    
      await this.$store.dispatch("workshop_vehicle/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.table = await this.$store.getters["workshop_vehicle/list"];
        var pageMeta  = await this.$store.getters["workshop_vehicle/page"];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta)
      this.totalDataTable = pageMeta.total
      this.numberOfPages = pageMeta['to']
      this.loadTable= false
    },
    searchButton(){
       this.options.page = 1;
      this.searchValue = this.search
      this.getList()
    },
    clearSearchButton(){
       this.options.page = 1;
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.getList()
    },

  

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    // if(this.$refs.vTable){
    //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    // }
    // else{
    //   this.exportAllFitered = this.dataExport(this.table)
    // }
    },

    // //fungsi untuk pinda ke page tambah
    // addData() {
    //   // panggil page add data
    //   this.$router.push({ name: "Add Vehicle" });
    // },

    addData(){
      this.$refs.modalAddPage.openModal()
    },
    modalCloseAdd(){
      this.$refs.modalAddPage.closeModal();
      this.getList();

    },

    editVehicle(id){
      this.$refs.modalEditPage.openModal({id:id})
    },

    modalCloseEdit(){
      this.$refs.modalEditPage.closeModal()
      this.getList();
    },

    detailVehicle(id){
      this.$refs.modalDetailPage.openModal({id:id})
    },
    modalCloseDetail(){
      this.$refs.modalDetailPage.closeModal()
      this.getList();
    },


    async dataExportBefore(type){
      if(this.table.length!=0){
        
      console.log("ewww")
        if(type=="all"){
          await this.$store.dispatch("workshop_vehicle/list");
          return this.dataExport(await this.$store.getters["workshop_vehicle/list"]);
        }
        else if(type=="filter"){

          var query = {}

            // if(sortBy.length!=0){
            //   var  sort=sortBy[0]
            //   if(sortDesc[0]){
            //     sort="-"+sortBy[0]
            //   }
            //   query.sort = sort
            // }

            if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }

            if(this.valueBusinessUnit!=0){
              if(query.filter){
                Object.assign(query.filter, {vehicle_business_unit:this.valueBusinessUnit});
              }
              else{
                query.filter = {vehicle_business_unit:this.valueBusinessUnit}
              }
            }

            if(this.valueVehicleType!=0){
              if(query.filter){
                Object.assign(query.filter, {vehicle_type:this.valueVehicleType});
              }
              else{
                query.filter = {vehicle_type:this.valueVehicleType}
              }
            }
          
            await this.$store.dispatch("workshop_vehicle/list",query);
             return this.dataExport(await this.$store.getters["workshop_vehicle/list"]);
        }
      }
      
    },
     dataExport(data){
        var dataReturn=[]
        data.forEach((value_1, index_1) => {
            var vehicle_body_color= null
            var vehicle_plate_color= null
            var vehicle_fuel_type= null
            var vehicle_businiss_unit = null
            var vehicle_model = null

            var vehicle_document_type = null

            var vehicle_accesory_type = null


            if(value_1.vehicle_type){
              vehicle_model = value_1.vehicle_type.vehicle_brands.vehicle_brand_name+', '+ value_1.vehicle_type.vehicle_model +' '+  value_1.vehicle_type.vehicle_year_model
              
              if(value_1.vehicle_type.vehicle_fuel_type == 1){
              vehicle_fuel_type = "Bensin"
                }
                else if(value_1.vehicle_plate_color == 2){
                  vehicle_fuel_type = "Diesel"
                }
                 else if(value_1.vehicle_plate_color == 3){
                  vehicle_fuel_type = "Listrik"
                }
                 else if(value_1.vehicle_plate_color == 4){
                  vehicle_fuel_type = "Hybrid"
                }
                 else if(value_1.vehicle_plate_color == 5){
                  vehicle_fuel_type = "CNG"
                }

            }
            

            if(value_1.vehicle_business_unit){
              vehicle_businiss_unit = value_1.vehicle_business_unit.business_unit_name
              }

            if(value_1.vehicle_plate_color == 0){
              vehicle_plate_color = "Kuning"
                }
                else if(value_1.vehicle_plate_color == 1){
                  vehicle_plate_color = "Hitam"
                }

            if(value_1.vehicle_body_color == 0){
              vehicle_body_color = "Putih"
                }
                else if(value_1.vehicle_body_color == 1){
                  vehicle_body_color = "Putih Kuning"
                }
                else if(value_1.vehicle_body_color == 2){
                  vehicle_body_color = "Putih Metalik"
                }
                else if(value_1.vehicle_body_color == 3){
                  vehicle_body_color = "Hitam"
                }
                else if(value_1.vehicle_body_color == 4){
                  vehicle_body_color = "Hitam Metalik"
                }
                else if(value_1.vehicle_body_color == 5){
                  vehicle_body_color = "Silver"
                }
                else if(value_1.vehicle_body_color == 6){
                  vehicle_body_color = "Silver Metalik"
                }
                else if(value_1.vehicle_body_color == 7){
                  vehicle_body_color = "Abu Abu"
                }
                else if(value_1.vehicle_body_color == 8){
                  vehicle_body_color = "Abu Abu Metalik"
                }
                else if(value_1.vehicle_body_color == 9){
                  vehicle_body_color = "Hijau"
                }

                for (let i = 0;  i < Math.max(value_1.vehicle_document.length, value_1.vehicle_accessory.length); i++) { 
                   var data= {
                          no:  dataReturn[index_1] && dataReturn[index_1].no == index_1+1 ? null : index_1+1,
                          vehicle_door_no: value_1.vehicle_door_no,
                          vehicle_plate_no: value_1.vehicle_plate_no,
                          vehicle_businiss_unit: vehicle_businiss_unit,
                          vehicle_model: vehicle_model,
                          vehicle_fuel_type: vehicle_fuel_type,
                          vehicle_body_color: vehicle_fuel_type,
                          vehicle_plate_color: vehicle_plate_color,
                          vehicle_registration_year: value_1.vehicle_registration_year,
                          vehicle_registration_name: value_1.vehicle_registration_name,
                          vehicle_production_year: value_1.vehicle_production_year,
                          vehicle_chassis_no: value_1.vehicle_chassis_no,
                          vehicle_engine_no: value_1.vehicle_engine_no,
                          no_document: value_1.vehicle_document[i]? i+1 : null,
                          vehicle_document_type: value_1.vehicle_document[i]? this.export_type('document',value_1.vehicle_document[i].vehicle_document_type)  : null,
                          vehicle_document_no: value_1.vehicle_document[i]? value_1.vehicle_document[i].vehicle_document_no : null,
                          vehicle_document_expire_date: value_1.vehicle_document[i]? value_1.vehicle_document[i].vehicle_document_expire_date : null,
                          vehicle_document_tax_expire_date: value_1.vehicle_document[i]? value_1.vehicle_document[i].vehicle_document_tax_expire_date : null,
                          vehicle_document_remark: value_1.vehicle_document[i]? value_1.vehicle_document[i].vehicle_document_remark : null,
                          
                          no_accesory: value_1.vehicle_accessory[i]? i+1 : null,
                          vehicle_accesory_type: value_1.vehicle_accessory[i]? this.export_type('accesory',value_1.vehicle_accessory[i].vehicle_accesory_type) : null,
                          vehicle_accesory_serial_no: value_1.vehicle_accessory[i]? value_1.vehicle_accessory[i].vehicle_accesory_serial_no : null,
                          vehicle_accesory_installation_date: value_1.vehicle_accessory[i]? value_1.vehicle_accessory[i].vehicle_accesory_installation_date : null,
                          vehicle_accesory_installation_by: value_1.vehicle_accessory[i]? value_1.vehicle_accessory[i].vehicle_accesory_installation_by : null,
                          vehicle_accesory_remark: value_1.vehicle_accessory[i]? value_1.vehicle_accessory[i].vehicle_accesory_remark : null,
                          created_at:  value_1.created_at,
                          updated_at:  value_1.created_at,

                        }
                    

                  
                      dataReturn.push(data)

                } 

        });
       return dataReturn
      
     
      
    },
      export_type(type,item){
        var return_data=null
        if(type =='document'){
           if(item == 0){
            return_data = "STNK"
          }
            else if(item == 1){
            return_data = "BPKB"
          }
            else if(item == 2){
            return_data = "KEUR"
          }
            else if(item == 3){
            return_data = "TERA"
          }
            else if(item == 4){
            return_data = "SRUT"
          }
            else if(item == 5){
            return_data = "KP"
          }
        }
        else if(type =='accesory'){
          if(item == 0){
             return_data = "RDS+SIM-CARD"
          }
          if(item == 1){
             return_data = "Bracket RDS"
          }
          if(item == 2){
             return_data = "Crown"
          }
          if(item == 3){
             return_data = "Emergency Lamp"
          }
          if(item == 4){
             return_data = "Vacancy Lamp"
          }
          if(item == 5){
             return_data = "Sticker"
          }
        }
      return return_data
      }
     },
  }
</script>
<style lang="scss" scoped>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}


</style>